import { ActionBar, Loader, LoaderSize, PrintIcon } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';
import { usePrint } from '../../print/PrintFrame.hooks';

import { StatisticsPreviewActionBarOrder } from './StatisticsPreviewActionBar';

type PrintActionProps = {
   readonly statisticsId: number;
};

export const PrintAction = (props: PrintActionProps): JSX.Element => {
   const { isLoading, onPrint } = usePrint(props.statisticsId);

   return (
      <ActionBar.OptionalLink
         testId='printDocuments'
         icon={isLoading ? <Loader testId={'loader'} size={LoaderSize.MEDIUM} /> : <PrintIcon />}
         name={'prints'}
         label={statisticsTranslationKeys.preview.print}
         order={StatisticsPreviewActionBarOrder.Print}
         onClick={onPrint}
      />
   );
};
